import { createElementBlock, createElementVNode, defineComponent, normalizeClass, openBlock, renderSlot } from "vue";
//#region src/components/ContextItem.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = { class: "contextItemText" };
var ContextItem_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "ContextItem",
	props: { loading: { type: Boolean } },
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["contextItem", { shimmer: __props.loading }]) }, [createElementVNode("span", _hoisted_1, [renderSlot(_ctx.$slots, "default", {}, void 0, true)])], 2);
		};
	}
});
//#endregion
export { ContextItem_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ContextItem.vue.script.js.map